export const inputStyle = (focus?: boolean, className?: string) =>
  `${className} w-full flex  rounded items-center justify-center py-4 px-3  focus-within:border-2 color-elr-black text-lg border-elr-border border ${
    focus ? 'focus-within:border-gray-700' : 'focus-within:border-elr-black'
  }`;
